/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetAttorneyDocTemplate404Response,
  GetCommonState400Response,
  GetRegistry404Response,
  GetTrademarkRequestInfo200Response,
  TrademarkRequestList200Response,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetAttorneyDocTemplate404ResponseFromJSON,
  GetAttorneyDocTemplate404ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetRegistry404ResponseFromJSON,
  GetRegistry404ResponseToJSON,
  GetTrademarkRequestInfo200ResponseFromJSON,
  GetTrademarkRequestInfo200ResponseToJSON,
  TrademarkRequestList200ResponseFromJSON,
  TrademarkRequestList200ResponseToJSON,
} from '../models/index'

export interface GetAttorneyDocTemplateRequest {
  registryPath: string
}

export interface GetTrademarkRequestInfoRequest {
  registryId: string
}

export interface TrademarkRequestListRequest {
  status?: TrademarkRequestListStatusEnum
  search?: string
  page?: number
  perPage?: number
}

/**
 * TrademarkRequestApi - interface
 *
 * @export
 * @interface TrademarkRequestApiInterface
 */
export interface TrademarkRequestApiInterface {
  /**
   * Файл PDF шаблона доверенности (registryPath — регистр для подстановки данных в шаблон). Требуется подтверждённый email.
   * @summary Файл шаблона доверенности
   * @param {string} registryPath Регистр для подстановки данных в шаблон
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrademarkRequestApiInterface
   */
  getAttorneyDocTemplateRaw(
    requestParameters: GetAttorneyDocTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>>

  /**
   * Файл PDF шаблона доверенности (registryPath — регистр для подстановки данных в шаблон). Требуется подтверждённый email.
   * Файл шаблона доверенности
   */
  getAttorneyDocTemplate(
    requestParameters: GetAttorneyDocTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob>

  /**
   * Краткая информация по регистру из кеша: наименование и адрес правообладателя, номер свидетельства, изображение знака. Данные кешируются на 3 часа. Требуется подтверждённый email.
   * @summary Краткая информация по регистру
   * @param {string} registryId Путь реестра: &lt;scope&gt;-&lt;база&gt;&lt;номер&gt;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrademarkRequestApiInterface
   */
  getTrademarkRequestInfoRaw(
    requestParameters: GetTrademarkRequestInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetTrademarkRequestInfo200Response>>

  /**
   * Краткая информация по регистру из кеша: наименование и адрес правообладателя, номер свидетельства, изображение знака. Данные кешируются на 3 часа. Требуется подтверждённый email.
   * Краткая информация по регистру
   */
  getTrademarkRequestInfo(
    requestParameters: GetTrademarkRequestInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetTrademarkRequestInfo200Response>

  /**
   * Постраничный список заявок текущего пользователя на продление срока действия ТЗ с фильтрами и статистикой по статусам (meta.countByStatus). Маршрут обобщён по разделам (/{section}); для SDK документирован раздел renewal. Требуется подтверждённый email.
   * @summary Список заявок на продление ТЗ
   * @param {'Draft' | 'Moderation' | 'Submitted' | 'Archive'} [status] Статус заявки (фильтр табуляции): Draft, Moderation, Submitted, Archive
   * @param {string} [search] Поисковая строка (2–150 символов)
   * @param {number} [page] Номер страницы (по умолчанию 1)
   * @param {number} [perPage] Записей на странице, 1–150
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrademarkRequestApiInterface
   */
  trademarkRequestListRaw(
    requestParameters: TrademarkRequestListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TrademarkRequestList200Response>>

  /**
   * Постраничный список заявок текущего пользователя на продление срока действия ТЗ с фильтрами и статистикой по статусам (meta.countByStatus). Маршрут обобщён по разделам (/{section}); для SDK документирован раздел renewal. Требуется подтверждённый email.
   * Список заявок на продление ТЗ
   */
  trademarkRequestList(
    requestParameters: TrademarkRequestListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TrademarkRequestList200Response>
}

/**
 *
 */
export class TrademarkRequestApi
  extends runtime.BaseAPI
  implements TrademarkRequestApiInterface
{
  /**
   * Файл PDF шаблона доверенности (registryPath — регистр для подстановки данных в шаблон). Требуется подтверждённый email.
   * Файл шаблона доверенности
   */
  async getAttorneyDocTemplateRaw(
    requestParameters: GetAttorneyDocTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    if (requestParameters['registryPath'] == null) {
      throw new runtime.RequiredError(
        'registryPath',
        'Required parameter "registryPath" was null or undefined when calling getAttorneyDocTemplate().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['registryPath'] != null) {
      queryParameters['registryPath'] = requestParameters['registryPath']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/trademark-request/stage1/attorney-doc-template`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.BlobApiResponse(response)
  }

  /**
   * Файл PDF шаблона доверенности (registryPath — регистр для подстановки данных в шаблон). Требуется подтверждённый email.
   * Файл шаблона доверенности
   */
  async getAttorneyDocTemplate(
    requestParameters: GetAttorneyDocTemplateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob> {
    const response = await this.getAttorneyDocTemplateRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Краткая информация по регистру из кеша: наименование и адрес правообладателя, номер свидетельства, изображение знака. Данные кешируются на 3 часа. Требуется подтверждённый email.
   * Краткая информация по регистру
   */
  async getTrademarkRequestInfoRaw(
    requestParameters: GetTrademarkRequestInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetTrademarkRequestInfo200Response>> {
    if (requestParameters['registryId'] == null) {
      throw new runtime.RequiredError(
        'registryId',
        'Required parameter "registryId" was null or undefined when calling getTrademarkRequestInfo().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/trademark-request/registries/{registryId}`.replace(
          `{${'registryId'}}`,
          encodeURIComponent(String(requestParameters['registryId']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetTrademarkRequestInfo200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Краткая информация по регистру из кеша: наименование и адрес правообладателя, номер свидетельства, изображение знака. Данные кешируются на 3 часа. Требуется подтверждённый email.
   * Краткая информация по регистру
   */
  async getTrademarkRequestInfo(
    requestParameters: GetTrademarkRequestInfoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetTrademarkRequestInfo200Response> {
    const response = await this.getTrademarkRequestInfoRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Постраничный список заявок текущего пользователя на продление срока действия ТЗ с фильтрами и статистикой по статусам (meta.countByStatus). Маршрут обобщён по разделам (/{section}); для SDK документирован раздел renewal. Требуется подтверждённый email.
   * Список заявок на продление ТЗ
   */
  async trademarkRequestListRaw(
    requestParameters: TrademarkRequestListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TrademarkRequestList200Response>> {
    const queryParameters: any = {}

    if (requestParameters['status'] != null) {
      queryParameters['status'] = requestParameters['status']
    }

    if (requestParameters['search'] != null) {
      queryParameters['search'] = requestParameters['search']
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/trademark-request/renewal`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TrademarkRequestList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Постраничный список заявок текущего пользователя на продление срока действия ТЗ с фильтрами и статистикой по статусам (meta.countByStatus). Маршрут обобщён по разделам (/{section}); для SDK документирован раздел renewal. Требуется подтверждённый email.
   * Список заявок на продление ТЗ
   */
  async trademarkRequestList(
    requestParameters: TrademarkRequestListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TrademarkRequestList200Response> {
    const response = await this.trademarkRequestListRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum TrademarkRequestListStatusEnum {
  Draft = 'Draft',
  Moderation = 'Moderation',
  Submitted = 'Submitted',
  Archive = 'Archive',
}
